import PureSkeleton from '@app/domains/common/components/PureSkeleton';

export default function HomeFeaturedCardSkeleton() {
    return (
        <div className="mt-4 flex h-320 w-full flex-col items-center rounded-12 bg-gray-100 px-20 pt-24 pb-15 dark:bg-gray-850 md:mt-8 md:h-248 md:flex-row md:px-32 md:py-36">
            <PureSkeleton
                className="mb-11 h-163 w-112 flex-shrink-0 rounded-tr-6 rounded-br-6 md:mr-32 md:mb-0 md:h-176 md:w-120"
                variant="rectangular"
                animation="pulse"
            />
            <div className="flex h-108 w-full flex-1 flex-col justify-center space-y-6 md:h-auto">
                <PureSkeleton className="h-24 w-[50%] md:h-32" variant="rectangular" animation="wave" />
                <PureSkeleton className="h-19 w-[30%] md:h-24 md:w-[15%]" variant="rectangular" animation="wave" />
                <PureSkeleton className="hidden md:block md:h-22 md:w-[25%]" variant="rectangular" animation="wave" />
                <PureSkeleton className="h-16 w-full md:h-19" variant="rectangular" animation="wave" />
                <PureSkeleton className="hidden h-16 w-full md:block md:h-19" variant="rectangular" animation="wave" />
            </div>
        </div>
    );
}
